(function() {
  var assetRoot = window.LANDING_ASSET_ROOT || '';

  window.landingAssetPath = function(path) {
    if (!path || !assetRoot) return path;
    if (path.indexOf('src/') === 0) return assetRoot + path.slice(4);
    return path;
  };
})();
